// AS TRADUÇÕES DO PAINEL — só as que se usam vão no pacote (02/10/2026).
//
// Medido em produção: o arquivo de JS principal tinha 12 MB (3,3 MB
// comprimido, 18 s para baixar do Brasil até o servidor na Europa), e 9 MB
// eram as traduções de 40 idiomas, todas importadas aqui de uma vez. O
// escritório usa português; o inglês é o idioma de reserva do vue-i18n (a
// chave sem tradução cai nele). Os outros idiomas viram um arquivo cada, baixado
// só quando alguém escolhe o idioma (`carregarIdioma`).
import en from './locale/en';
import pt_BR from './locale/pt_BR';

// Todos os idiomas de `locale/`, menos os dois que já vêm no pacote e a pasta
// `zh`, incompleta, que nunca entrou no painel e não compila (bn e et nem têm
// index.js).
const CARREGADORES = import.meta.glob([
  './locale/*/index.js',
  '!./locale/en/index.js',
  '!./locale/pt_BR/index.js',
  '!./locale/zh/index.js',
]);

const caminho = locale => `./locale/${locale}/index.js`;

export const idiomaDisponivel = locale =>
  ['en', 'pt_BR'].includes(locale) || Boolean(CARREGADORES[caminho(locale)]);

/**
 * Garante as mensagens de `locale` no i18n (o `$i18n` / `i18n.global`) e
 * devolve se o idioma existe. Idioma desconhecido não troca nada.
 */
export async function carregarIdioma(i18n, locale) {
  if (!locale) return false;
  if (i18n.availableLocales?.includes(locale)) return true;
  const carregar = CARREGADORES[caminho(locale)];
  if (!carregar) return false;
  const modulo = await carregar();
  i18n.setLocaleMessage(locale, modulo.default);
  return true;
}

export default { en, pt_BR };
